module.exports = __webpack_public_path__ + "img/source_sw-con05.b326d2ec.png";